import { Link } from "react-router-dom";

const sections = [
  [
    "1. A quem esta política se aplica",
    [
      "Esta política se aplica às pessoas que acessam o site da Sengia, entram em contato pelos canais disponibilizados ou interagem com organizações que utilizam a plataforma Sengia para atendimento e comunicação.",
      "Quando uma organização utiliza a Sengia para atender seus próprios clientes, essa organização define as finalidades e os meios essenciais do tratamento dos dados de seus contatos e atua como controladora. A Sengia trata esses dados em nome da organização, de acordo com as instruções contratadas e com a legislação aplicável. Para dados coletados diretamente em seu próprio site e canais institucionais, a Sengia poderá atuar como controladora.",
    ],
  ],
  [
    "2. Dados pessoais que podem ser tratados",
    [
      "Conforme a forma de interação e as configurações da organização responsável pelo atendimento, poderão ser tratados: dados de identificação e contato; conteúdo de mensagens e arquivos; informações necessárias para executar solicitações, agendamentos, protocolos ou outros serviços; decisão sobre o recebimento de ofertas, novidades e promoções pelo WhatsApp, incluindo data e identificadores técnicos necessários para comprovar a resposta; dados técnicos de acesso; e registros necessários à segurança, prevenção de abuso, diagnóstico e auditoria.",
      "A Sengia e as organizações que utilizam a plataforma devem limitar a coleta ao que for adequado e necessário para cada finalidade. Não envie dados sensíveis ou documentos que não tenham sido solicitados para a execução do atendimento.",
    ],
  ],
  [
    "3. Finalidades do tratamento",
    [
      "Os dados poderão ser tratados para viabilizar atendimentos; identificar o contato e manter o contexto; responder solicitações e executar serviços; realizar agendamentos, registrar protocolos e encaminhar atendimentos; enviar ofertas, novidades e promoções pelo WhatsApp somente com consentimento válido; registrar e demonstrar a obtenção, recusa ou exclusão do consentimento; manter a segurança e confiabilidade; cumprir obrigações legais; e exercer direitos em processos administrativos, arbitrais ou judiciais.",
    ],
  ],
  [
    "4. Consentimento para marketing pelo WhatsApp",
    [
      "Quando essa funcionalidade estiver habilitada pela organização responsável pelo atendimento, você poderá escolher se deseja receber ofertas, novidades e promoções pelo WhatsApp. As opções de aceitar e recusar são apresentadas antes do prosseguimento do atendimento.",
      "A recusa ao marketing não impede o atendimento nem reduz o acesso aos serviços solicitados. Sua decisão será registrada para que a preferência seja respeitada. O consentimento poderá ser retirado a qualquer momento pelos canais oficiais da organização que realiza o atendimento. Após a retirada ou exclusão do registro, uma nova autorização poderá ser solicitada em atendimento futuro.",
      "Mensagens estritamente necessárias para responder a uma solicitação, executar um serviço ou informar sobre uma relação já existente não devem ser tratadas como campanhas de marketing apenas por utilizarem o WhatsApp.",
    ],
  ],
  [
    "5. Bases legais",
    [
      "O tratamento poderá se apoiar, conforme o caso, no consentimento, na execução de contrato ou de procedimentos preliminares solicitados pelo titular, no cumprimento de obrigação legal ou regulatória, no exercício regular de direitos, na proteção da vida ou da incolumidade física e no legítimo interesse, sempre com avaliação dos direitos e das expectativas do titular.",
      "Para campanhas de ofertas, novidades e promoções via WhatsApp abrangidas por esta funcionalidade, a base utilizada será o consentimento manifestado pelo próprio contato.",
    ],
  ],
  [
    "6. Compartilhamento de dados",
    [
      "Os dados poderão ser compartilhados, na medida necessária, com a organização responsável pelo atendimento e seus usuários autorizados; provedores de WhatsApp e parceiros de entrega; provedores de infraestrutura, armazenamento, segurança, suporte e tecnologia; autoridades públicas, quando houver obrigação legal ou ordem válida; e assessores necessários ao exercício regular de direitos.",
      "Os terceiros devem receber apenas os dados necessários às suas atividades e tratá-los de acordo com obrigações contratuais e legais aplicáveis.",
    ],
  ],
  [
    "7. Transferências internacionais",
    [
      "Alguns provedores tecnológicos podem processar ou armazenar dados fora do Brasil. Quando isso ocorrer, devem ser adotadas medidas compatíveis com a legislação brasileira para proteger os dados pessoais e assegurar garantias adequadas ao tratamento.",
    ],
  ],
  [
    "8. Retenção e exclusão",
    [
      "Os dados são mantidos pelo tempo necessário para cumprir as finalidades informadas, atender às configurações e instruções da organização responsável pelo atendimento, observar prazos legais e regulatórios e permitir o exercício regular de direitos.",
      "O prazo pode variar conforme a natureza do dado e do serviço. Ao término do tratamento, os dados serão eliminados, anonimizados ou conservados apenas nas hipóteses permitidas pela legislação.",
    ],
  ],
  [
    "9. Segurança",
    [
      "São adotadas medidas técnicas e administrativas razoáveis para proteger os dados contra acesso não autorizado e situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou difusão. Nenhum ambiente é completamente imune a riscos; incidentes confirmados serão tratados de acordo com sua natureza e com as obrigações legais aplicáveis.",
    ],
  ],
  [
    "10. Direitos dos titulares",
    [
      "Nos termos da Lei Geral de Proteção de Dados Pessoais, você poderá solicitar, quando aplicável: confirmação e acesso; correção; anonimização, bloqueio ou eliminação; portabilidade; informação sobre compartilhamentos e sobre a possibilidade de negar consentimento; revogação e eliminação de dados tratados com consentimento; revisão de decisões automatizadas; e oposição a tratamento em desconformidade.",
      "Poderá ser necessário confirmar a identidade do solicitante. Quando os dados forem controlados por uma organização cliente da Sengia, a solicitação deverá ser direcionada prioritariamente a essa organização, responsável por decidir sobre o atendimento do direito.",
    ],
  ],
  [
    "11. Crianças e adolescentes",
    [
      "A plataforma não deve ser usada para coletar intencionalmente dados de crianças e adolescentes sem uma finalidade legítima e sem a observância das regras específicas aplicáveis, inclusive o melhor interesse do menor e, quando exigido, a participação de seus responsáveis legais.",
    ],
  ],
  [
    "12. Cookies e tecnologias semelhantes",
    [
      "O site poderá utilizar armazenamento local, cookies estritamente necessários ou tecnologias equivalentes para funcionamento, segurança e manutenção de sessão. Caso sejam adotadas tecnologias não essenciais para análise, publicidade ou rastreamento, deverão ser apresentados os controles e avisos exigidos pela legislação antes de sua ativação.",
    ],
  ],
  [
    "13. Alterações desta política",
    [
      "Esta política poderá ser atualizada para refletir mudanças legais, operacionais ou tecnológicas. A versão vigente e a data da última atualização permanecerão disponíveis nesta página. Alterações relevantes poderão ser comunicadas pelos canais apropriados.",
    ],
  ],
  [
    "14. Contato",
    [
      "Para dúvidas sobre esta política ou para exercer direitos relacionados a dados tratados diretamente pela Sengia, utilize o formulário disponível na seção de contato do site. Quando a solicitação estiver relacionada a um atendimento realizado por uma organização que utiliza a plataforma, entre em contato também com essa organização pelos canais oficiais informados por ela.",
    ],
  ],
] as const;

export default function PrivacyPolicyPage() {
  return (
    <main className="min-h-screen bg-slate-50 text-slate-800">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-5">
          <Link to="/" className="text-xl font-semibold text-slate-900">
            Sengia
          </Link>
          <Link to="/" className="text-sm text-blue-600 hover:underline">
            Voltar ao início
          </Link>
        </div>
      </header>
      <article className="mx-auto max-w-4xl px-6 py-12 sm:py-16">
        <h1 className="text-3xl font-semibold text-slate-950 sm:text-4xl">
          Política de Privacidade
        </h1>
        <p className="mt-3 font-semibold">
          Última atualização: 18 de outubro de 2026
        </p>
        <p className="mt-6 leading-7">
          A Sengia respeita a sua privacidade e está comprometida com a proteção
          dos dados pessoais tratados em seus sites, canais de contato e
          plataforma de atendimento. Esta Política de Privacidade explica quais
          dados podem ser tratados, para quais finalidades, com quem podem ser
          compartilhados, por quanto tempo podem ser mantidos e quais direitos
          podem ser exercidos por seus titulares.
        </p>
        <div className="mt-10 space-y-10">
          {sections.map(([title, paragraphs]) => (
            <section key={title}>
              <h2 className="text-xl font-semibold text-slate-950">{title}</h2>
              {paragraphs.map((paragraph) => (
                <p key={paragraph} className="mt-4 leading-7">
                  {paragraph}
                </p>
              ))}
            </section>
          ))}
        </div>
      </article>
    </main>
  );
}
